import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';

export interface MeasurementAction {
  labelKey: string;
  icon: string;
  action: () => void;
}

@Component({
  selector: 'cosmos-measurement-actions-menu',
  templateUrl: './measurement-actions-menu.component.html',
  imports: [TranslatePipe, ButtonModule, MenuModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasurementActionsMenuComponent {
  private readonly translateService = inject(TranslateService);

  readonly actions = input.required<MeasurementAction[]>();
  /** When true, render only the ellipsis icon (no "More actions" label) —
   *  for compact rows/cards where horizontal space is tight. */
  readonly iconOnly = input<boolean>(false);

  readonly menuItems = computed<MenuItem[]>(() =>
    this.actions().map((a) => ({
      label: this.translateService.instant(a.labelKey),
      icon: a.icon,
      command: () => a.action(),
    }))
  );
}
